// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1) return "assets/app/lottie_light.min.js";
	if (chunkId === 268) return "assets/app/flickity.js";
	// return url for filenames based on template
	return undefined;
};